import { Grid, Box, Typography, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DefaultImprint = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-document-content">
      <p>
        <b>
          {t("imprint.heading")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-1")}
          <a href="http://www.futurecare.digital">www.futurecare.digital</a>.
          {t("imprint.line-2")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-3")}
          <br></br>
          {t("imprint.line-4")}
          <br></br>
          {t("imprint.line-5")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-6")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-7")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-8")}
          <br></br>
          {t("imprint.line-9")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-10")}
          <br></br>
          <br></br>
          {t("imprint.line-11")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-12")}:<br></br>
          <br></br>
          {t("imprint.line-13")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-14")}
          <br></br>
          <br></br>
          {t("imprint.line-15")}
          <br></br>
          <br></br>
          {t("imprint.line-16")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-17")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-18")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-19")}
          <br></br>
          <br></br>
          {t("imprint.line-20")}
          <br></br>
          {t("imprint.line-21")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-22")}
          <br></br>
          <br></br>
          {t("imprint.line-23")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-24")}
          <br></br>
          <br></br>
          {t("imprint.line-25")}
          <br></br>
          <br></br>
          <br></br>
          {t("imprint.line-26")}
          <br></br>
          <br></br>
          {t("imprint.line-27")}
          <br></br>
          {t("imprint.line-28")}
        </b>
      </p>
    </div>
  );
};

export default DefaultImprint;
